<template>
  <div class="engine-card monitor-card">
    <div class="engine-card-title">环境因子监测</div>
    <div ref="gaugeRef" class="gauge-chart"></div>
    <div class="monitor-grid">
      <span>土壤湿度</span><span>气温</span><b>68%</b><b>31.6℃</b>
      <span>光照</span><span>EC值</span><b>41200lux</b><b>1.8ms/cm</b>
    </div>
  </div>
</template>

<script setup>
import * as echarts from "echarts";
import { onBeforeUnmount, onMounted, ref } from "vue";

const gaugeRef = ref(null);
let chartInstance = null;

function resizeChart() {
  chartInstance && chartInstance.resize();
}

onMounted(() => {
  chartInstance = echarts.init(gaugeRef.value);
  chartInstance.setOption({
    series: [
      {
        type: "gauge",
        startAngle: 210,
        endAngle: -30,
        min: 0,
        max: 100,
        radius: "100%",
        center: ["50%", "58%"],
        splitNumber: 4,
        progress: {
          show: true,
          width: 18,
          itemStyle: { color: "#1dffe4" },
        },
        axisLine: {
          lineStyle: {
            width: 18,
            color: [
              [0.68, "#1dffe4"],
              [0.88, "#f0df5d"],
              [1, "rgba(255, 255, 255, 0.12)"],
            ],
          },
        },
        axisTick: {
          distance: -34,
          length: 6,
          lineStyle: { color: "rgba(185, 255, 247, 0.46)", width: 2 },
        },
        splitLine: {
          distance: -38,
          length: 12,
          lineStyle: { color: "rgba(185, 255, 247, 0.55)", width: 2 },
        },
        axisLabel: {
          distance: -30,
          color: "rgba(205, 255, 249, 0.38)",
          fontSize: 22,
        },
        pointer: { show: false },
        anchor: { show: false },
        title: {
          show: true,
          offsetCenter: [0, "28%"],
          color: "#fff",
          fontSize: 22,
          fontWeight: "bold",
        },
        detail: {
          valueAnimation: false,
          offsetCenter: [0, "0%"],
          formatter: "{value}%",
          color: "#70fff4",
          fontSize: 42,
          fontWeight: "bold",
        },
        data: [{ value: 68, name: "土壤湿度" }],
      },
    ],
  });
  window.addEventListener("resize", resizeChart);
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", resizeChart);
  chartInstance && chartInstance.dispose();
});
</script>

<style lang="less" scoped>
.engine-card {
  position: relative;
  min-width: 0;
  border: 2px solid rgba(57, 255, 238, 0.72);
  background:
    linear-gradient(180deg, rgba(0, 98, 85, 0.22), rgba(0, 38, 36, 0.58)),
    rgba(4, 45, 42, 0.72);
  box-shadow:
    inset 0 0 34px rgba(33, 255, 233, 0.13),
    0 0 22px rgba(33, 255, 233, 0.08);
  box-sizing: border-box;
}

.engine-card::before,
.engine-card::after {
  content: "";
  position: absolute;
  width: 82px;
  height: 34px;
  border-color: #30fff0;
  border-style: solid;
  pointer-events: none;
}

.engine-card::before {
  left: -2px;
  top: -2px;
  border-width: 2px 0 0 2px;
}

.engine-card::after {
  right: -2px;
  bottom: -2px;
  border-width: 0 2px 2px 0;
}

.engine-card-title {
  width: 260px;
  height: 58px;
  margin: 24px auto 0;
  color: #ffffff;
  font-size: 32px;
  font-weight: bold;
  line-height: 58px;
  text-align: center;
  background: linear-gradient(90deg, transparent, rgba(27, 180, 158, 0.76), transparent);
  text-shadow: 0 0 12px rgba(255, 255, 255, 0.32);
}

.monitor-card {
  height: 632px;
  padding: 0 34px 32px;
  display: flex;
  flex-direction: column;
  gap: 50px;
}

.gauge-chart {
  width: 360px;
  height: 185px;
  margin: 12px auto 2px;
}

.monitor-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 42px;
  row-gap: 7px;
  text-align: left;
}

.monitor-grid span {
  color: #f6fffd;
  font-size: 28px;
  line-height: 40px;
}

.monitor-grid b {
  color: #ffffff;
  font-size: 22px;
  line-height: 28px;
}
</style>
